import type { ComponentProps } from 'react';
import type { SxProps, Theme } from '@mui/material';

import { DatePicker } from '@theguarantors/tg-package-material-ui';

export type RenterInviteDatePickerProps = Omit<ComponentProps<typeof DatePicker>, 'label'> & {
  label?: string;
  sx?: SxProps<Theme>;
  error?: string;
};

export const RenterInviteDatePicker = ({
  label = '',
  sx = {},
  slotProps,
  error,
  ...props
}: RenterInviteDatePickerProps) => {
  return (
    <DatePicker
      color="secondary"
      label={label}
      {...props}
      slotProps={{
        ...slotProps,
        textField: {
          required: true,
          size: 'small',
          error: Boolean(error),
          helperText: error,
          InputLabelProps: {
            shrink: Boolean(props.value),
          },
          ...slotProps?.textField,
          sx: {
            '& .MuiInputBase-input::placeholder': {
              opacity: 1,
            },
            '& .MuiFormLabel-asterisk': {
              color: 'red !important',
            },
            ...sx,
          },
        },
      }}
    />
  );
};
